import { createRoutine } from '../common/utils/routines';

export const login = createRoutine('netlifyAddon/LOGIN');
